import MaterialDialogContent, {
    DialogContentProps,
} from '@mui/material/DialogContent';

export function DialogContent(props: DialogContentProps) {
    return (
        <MaterialDialogContent
            data-testid={'DialogContent-container'}
            {...props}
        />
    );
}

export default DialogContent;
